export const registerServiceWorker = () => {
  if (!("serviceWorker" in navigator)) return;
  // Only register on http(s), not during yarn start file:// / dev HMR issues
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => {
        // Silent — PWA install is a progressive enhancement
        console.warn("SW registration failed", err);
      });
  });
};
